export const PERMISSIONS_MAP = {
  View: 'view',
  Modify: 'modify',
  FullControl: 'full_control',
} as const;
